import * as Yup from "yup";
import { loginDocument } from "../../validation/validators/formSchema";
export var validationLoginSchema = Yup.object({
    document: loginDocument,
});
